import React, { createContext, useContext } from 'react';

/**
 * Produkttexte der Jury-Oberflaeche (Teilnehmer vs. Projekte, Sortieroptionen).
 *
 * Die Texte sind der einzige Teil des Jury-Bereichs, der sich zwischen den
 * Produktlinien redaktionell unterscheidet. Sie kommen deshalb als Daten von der
 * Aufrufstelle (`JuryShell copy={...}`) herein; die Vorgaben hier sind die
 * Formulierung der Wettbewerbs-Produktlinie und halten deren Ausgabe unveraendert.
 */
export const DEFAULT_JURY_COPY = {
    /** Bezeichnung eines Eintrags in der Projektliste. */
    entityLabel: 'Teilnehmer',
    /** Meldung, wenn die Projektliste leer ist. */
    emptyProjectListMessage: 'Keine Teilnehmer gefunden.',
    /** Platzhalter des Suchfelds. */
    searchPlaceholder: 'Suche nach Teilnehmern oder Institutionen...',
    /** Auswahl des Sortierfelds. */
    sortOptions: [
        { value: 'name', label: 'Teilnehmername' },
        { value: 'title', label: 'Projekttitel' },
        { value: 'voteCount', label: 'Stimmen (Qualifikation)' },
        { value: 'voteCountFinale', label: 'Stimmen (Finale)' },
    ],
};

const JuryCopyContext = createContext(DEFAULT_JURY_COPY);

/** Reicht die Texte an alle Jury-Seiten weiter, ohne sie durch jede Ebene zu geben. */
export const JuryCopyProvider = ({ copy, children }) => (
    <JuryCopyContext.Provider value={{ ...DEFAULT_JURY_COPY, ...copy }}>{children}</JuryCopyContext.Provider>
);

export const useJuryCopy = () => useContext(JuryCopyContext);
